<template>
  <div class="pagination" v-if="hasPages">
    <Btn subtle :isDisabled="page <= 1" @click="previous">
      Prev
    </Btn>

    <span class="count">Page {{ page }} of {{ pages }}</span>

    <Btn subtle :isDisabled="pages <= page" @click="next">
      Next
    </Btn>

    <select v-model="perPage">
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </select>
  </div>
</template>

<script>
import Btn from '@/components/Btn'

export default {
  name: 'Pagination',

  props: {
    pagination: {
      type: Object,
      required: true
    }
  },

  components: {Btn},

  computed: {
    page() {
      if (this.pagination.page_number) {
        return parseInt(this.pagination.page_number)
      } else {
        return 0
      }
    },

    pages() {
      if (this.pagination.total_pages) {
        return parseInt(this.pagination.total_pages)
      } else {
        return 0
      }
    },

    hasPages() {
      return this.pagination.total_entries > 10
    },

    perPage: {
      get() {
        return this.pagination.page_size
      },

      set(newValue) {
        let page = this.pagination
        page.page_size = newValue
        this.$emit('changePage', page)
      }
    }
  },

  methods: {
    next() {
      this.$emit('changePage', {page: this.page + 1})
    },

    previous() {
      this.$emit('changePage', {page: this.page - 1})
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.pagination
  display: flex
  align-items: center
  justify-content: flex-end

  .count
    margin: 0 10px

  .btn
    padding: 7px
    margin: 0 10px
    position: relative
    top: -1px
    font-size: 12px

  select
    font-size: 11px
</style>
